export default __webpack_public_path__ + "static/media/user.81d7b418.svg";